var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1750407752558,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 5486,
    width: 16,
    height: 16,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M511.500488 959.063415C264.317877 959.063415 63.937561 758.683099 63.937561 511.500488S264.317877 63.937561 511.500488 63.937561s447.562927 200.380316 447.562927 447.562927-200.380316 447.562927-447.562927 447.562927z m0-63.937561c211.870096 0 383.625366-171.75527 383.625366-383.625366S723.370583 127.875122 511.500488 127.875122 127.875122 299.630392 127.875122 511.500488s171.75527 383.625366 383.625366 383.625366z m-87.520531-310.033234a3.996098 3.996098 0 0 0 4.894221-0.402606L700.315099 335.022829a7.992195 7.992195 0 0 1 5.657475-2.347707h70.694962a3.996098 3.996098 0 0 1 2.825241 6.821338L459.548222 679.421502c-15.604761 15.60576-40.908051 15.60576-56.51381 0L222.954271 509.330607A3.996098 3.996098 0 0 1 225.779512 502.509268h69.961678a7.992195 7.992195 0 0 1 5.650482 2.339715l122.588285 80.243637z",
    fill: "#D8D8D8",
    "p-id": 5487
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.7bbb45d8172ff1c0d88630c29a4947bf.svg";
export { ForwardRef as ReactComponent };